class ATagDownloadUtils {
  private aTag;
  private href: string | null = null;
  private fileName: string | null = null;

  constructor() {
    const aTag = document.createElement('a');
    // aTag.download = 'test.mp4';
    this.aTag = aTag;
  }

  public setHref(href: string) {
    this.href = href;
    return this;
  }

  public setFileName(fileName: string) {
    this.fileName = fileName;
    return this;
  }

  private build() {
    if (this.href == null) {
      throw new Error('[ATagDownloadUtils] 다운로드하기 위한 프로퍼티가 충족되지 않았습니다.');
    }

    this.aTag.href = this.href;

    if (this.fileName) {
      this.aTag.download = this.fileName;
    }
  }

  public download() {
    this.build();
    document.body.appendChild(this.aTag);
    this.aTag.click();
  }

  public close() {
    document.body.removeChild(this.aTag);
  }
}

export default ATagDownloadUtils;
